// extracted by mini-css-extract-plugin
export default {"CreateContractIconArea":"_CreateContractIconArea--L8bwQ"};